import { Reducer } from 'redux';
import { ApiRequestStartActionTypes, ApiRequestEndActionTypes } from './types';

export interface ApplicationState {
    loadingData: LoadingData;
}

export interface LoadingData {
    activeRequests: number;
    isLoading: boolean;
}

const unloadedState: ApplicationState = { loadingData: { activeRequests: 0, isLoading: false } } as ApplicationState;

export const applicationReducer: Reducer<ApplicationState> = (state: ApplicationState | undefined, action): ApplicationState => {
    if (!state) {
        return unloadedState;
    }

    switch (action.type) {
        case ApiRequestStartActionTypes.REQUEST:
            return { ...state, loadingData: { activeRequests: state.loadingData.activeRequests + 1, isLoading: true} }
        case ApiRequestEndActionTypes.REQUEST:
            return { ...state, loadingData: { activeRequests: state.loadingData.activeRequests - 1, isLoading: state.loadingData.activeRequests > 1 } }
        default:
            return state;
    }
}
